import { render } from "./AgentsTable.vue?vue&type=template&id=76b0c1f0"
import script from "./AgentsTable.vue?vue&type=script&lang=js"
export * from "./AgentsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__